// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const GlossaryIndex: MarkdocTagRegistration = {
  tag: 'glossary-index',
  component: 'GlossaryIndex',
};
